import React from "react";

export default function UAUCUnresolvedHeader({
  title,
  query,
  setQuery,
  assignees,
  assignedToId,
  setAssignedToId,
  advOpen,
  setAdvOpen,
  onBack,
  stats,
}) {
  return (
    <div className="rounded-t-3xl bg-gradient-to-br from-slate-950 via-slate-900 to-red-950 px-5 py-5 text-white">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <p className="text-xs font-black uppercase tracking-[0.18em] text-red-300">
            Action Tracker
          </p>
          <h4 className="mt-2 text-2xl font-black tracking-tight">{title}</h4>
          <p className="mt-1 text-sm font-medium text-slate-300">
            Monitor unresolved observations by assignee, SLA status, risk and
            closure performance.
          </p>
        </div>

        <div className="flex flex-wrap items-center gap-2">
          <input
            type="text"
            className="h-11 w-72 rounded-2xl border border-white/10 bg-white/10 px-4 text-sm font-bold text-white outline-none placeholder:text-slate-400 focus:border-red-300"
            placeholder="Search observer, area, hazards..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />

          <select
            className="h-11 rounded-2xl border border-white/10 bg-white/10 px-3 text-sm font-bold text-white outline-none"
            value={assignedToId}
            onChange={(e) => setAssignedToId(e.target.value)}
          >
            <option value="">All Assignees</option>
            {assignees.map((a) => (
              <option key={a.id} value={a.id} className="text-slate-900">
                {a.name}
              </option>
            ))}
          </select>

          <button
            type="button"
            className="h-11 rounded-2xl bg-white px-4 text-sm font-black text-slate-950"
            onClick={() => setAdvOpen((v) => !v)}
          >
            {advOpen ? "Close Filters" : "Advanced Filters"}
          </button>

          {onBack && (
            <button
              type="button"
              onClick={onBack}
              className="h-11 rounded-2xl border border-white/10 bg-white/10 px-4 text-sm font-black text-white"
            >
              Back
            </button>
          )}
        </div>
      </div>

      <div className="mt-5 grid grid-cols-2 gap-3 lg:grid-cols-4">
        {[
          ["Open", stats.total],
          ["Assignees", stats.assignees],
          ["Overdue", stats.overdue],
          ["High Risk", stats.critical],
        ].map(([label, value]) => (
          <div
            key={label}
            className="rounded-2xl border border-white/10 bg-white/10 p-4"
          >
            <p className="text-xs font-bold uppercase tracking-wide text-slate-300">
              {label}
            </p>
            <p className="mt-2 text-2xl font-black tabular-nums">{value}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
